import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetManagedMeetingsTemplates as GetManagedMeetingsTemplatesQuery,
    GetManagedMeetingsTemplatesVariables as GetManagedMeetingsTemplatesVariables,
    GetManagedMeetingsTemplates_managedMeetings as ManagedMeetings,
} from 'nutshell-graphql-types';

import GET_MANAGED_MEETINGS_TEMPLATES from '../queries/get-managed-meetings-templates.graphql';

export const useGetManagedMeetingsTemplates = (
    archived: boolean
): {
    managedMeetings: ManagedMeetings[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetManagedMeetingsTemplatesQuery,
        GetManagedMeetingsTemplatesVariables
    >(GET_MANAGED_MEETINGS_TEMPLATES, {
        fetchPolicy: 'cache-and-network',
        variables: {
            archived,
        },
    });

    const managedMeetings = data ? data.managedMeetings : null;

    return {
        managedMeetings: managedMeetings || [],
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
